var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonatC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 35C70 54.33 54.33 70 35 70C15.67 70 0 54.33 0 35C0 15.67 15.67 0 35 0C54.33 0 70 15.67 70 35ZM56.001 35C56.001 46.598 46.599 56 35.001 56C23.403 56 14.001 46.598 14.001 35C14.001 23.402 23.403 14 35.001 14C46.599 14 56.001 23.402 56.001 35Z",
    fill: "#B79776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 35C70 54.33 54.33 70 35 70V56C35.0003 56 35.0007 56 35.001 56C46.599 56 56.001 46.598 56.001 35C56.001 23.402 46.599 14 35.001 14C35.0007 14 35.0003 14 35 14V0C54.33 0 70 15.67 70 35Z",
    fill: "#0B45E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonatC);
export default __webpack_public_path__ + "static/media/donat_c.bc7ee0062396e1839604ecc5f41a5ff6.svg";
export { ForwardRef as ReactComponent };